import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { formatDate } from '@/lib/formatUtils';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportDataClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  fromDate?: string;
  toDate?: string;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onExportDataClick,
  onEditPrintTemplateClick,
  className,
  fromDate,
  toDate
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Báo cáo tổng hợp bán hàng thuần</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>Từ ngày {formatDate(fromDate || '')}</span>
              <span> đến ngày </span>
              <span className='font-semibold'>{formatDate(toDate || '')}</span>
            </p>
          </div>
        </div>
      }
    >
      {onSearchClick && (
        <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      )}
      <MenuButtonV2
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} />}
        items={[
          {
            title: 'Theo vật tư (Giá trị)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo vật tư (Số lượng, Giá trị)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo vật tư (Số lượng, Giá trị ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo khách hàng (Giá trị)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo khách hàng (Số lượng, Giá trị)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo khách hàng, vật tư (Giá trị)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo khách hàng, vật tư (Số lượng, Giá trị)',
            icon: <AritoIcon icon={20} />,
            group: 0
          },
          {
            title: 'Theo vật tư (Giá trị) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          },
          {
            title: 'Theo vật tư (Số lượng, Giá trị) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          },
          {
            title: 'Theo vật tư (Số lượng, Giá trị ngoại tệ) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          },
          {
            title: 'Theo khách hàng (Giá trị) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          },
          {
            title: 'Theo khách hàng (Số lượng, Giá trị) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          },
          {
            title: 'Theo khách hàng, vật tư (Giá trị) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          },
          {
            title: 'Theo khách hàng, vật tư (Số lượng, Giá trị) - Song ngữ',
            icon: <AritoIcon icon={20} />,
            group: 1
          }
        ]}
      />
      {/* No print button */}
      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      {onExportDataClick && (
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onExportDataClick}
          variant='secondary'
        />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
